// extracted by mini-css-extract-plugin
export default {"root":"styles_root__NPBXW","label":"styles_label__7iRu+","selected":"styles_selected__8gqvT","input":"styles_input__KfbUE"};